import { render, staticRenderFns } from "./RadioChoice.vue?vue&type=template&id=4d922e61"
import script from "./RadioChoice.vue?vue&type=script&lang=js"
export * from "./RadioChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RadioChoice.vue?vue&type=custom&index=0&blockType=RadioChoice&%3Atitle=radioChoice.title&%3Aitems=radioChoice.fields&v-model=%7BuourModel%7D&%40change=setValue"
if (typeof block0 === 'function') block0(component)

export default component.exports